export default __webpack_public_path__ + "static/rendition-downsized-example-d909f0ab8e1b908d18c2d67b5057b149.gif";